import type { ReactElement } from 'react';

export namespace Formatter {
  export const mailto = (value: string): ReactElement => <a href={`mailto:${value}`}>{value}</a>;

  export const tel = (value: string): ReactElement => <a href={`tel:${value}`}>{value}</a>;
}
